import Vue from 'vue';
import HandleResponses from '@common/utils/handleResponses';
import { StatusUtils } from 'status-utils';
import axios from '@/axios';
import getDecrypt from '../../../utils/permission';
import CryptoJS from 'crypto-js';
import HandleResponsesV2 from '@common/utils/handleApiResponsesV2';
import Constants from '@common/constants/ResponseConstants';

const actions = {

  async currentClient({ commit }, data) {
    commit('CURRENT_CLIENT', data);
    return data;
  },
  async mdmBootstrap({ commit }) {
    try {
      const result = await axios('/bootstrap/mdm');
      commit('MDM_BOOTSTRAP_DATA', result.data);
      commit('BOOTSTRAP_LOADING', true);
      commit('LOGGED_IN', true);
      return result.data;
    } catch (err) {
      return err;
    } finally {
      commit('BOOTSTRAP_LOADING', false);
    }
  },
  async bootstrap({ commit }, trigger = false) {
    try {
      if (!trigger) {
        commit('BOOTSTRAP_LOADING', true);
      } else {
        commit('BOOTSTRAP_RELOADING', true);
      }
      const result = await axios('/bootstrap');
      const statusUtils =
        new StatusUtils(result.data.status.list, result.data.status.mapping);
      const currentUser = (result.data && result.data.current_user);
      const currentClient = (result.data && result.data.clients) ? result.data.clients[0] : {};
      if (currentUser) {
        currentUser.permission_list =
        getDecrypt(currentUser.permission_list, currentUser.id);
      }
      currentClient.features = getDecrypt(currentClient.features, currentClient.id);
      Vue.prototype.$statusUtil = statusUtils;
      commit('BOOTSTRAP_DATA', result.data);
      const currentClientConfig = (result.data && result.data.client_config) ? result.data.client_config[0] : {};
      commit('CURRENT_CLIENT', currentClient);
      commit('CURRENT_CLIENT_CONFIG', currentClientConfig);
      commit('LOGGED_IN', true);
      return result.data;
    } catch (err) {
      return err;
    } finally {
      if (!trigger) {
        commit('BOOTSTRAP_LOADING', false);
      } else {
        commit('BOOTSTRAP_RELOADING', false);
      }
    }
  },


  async forgotPassword(_, { data }) {
    try {
      const result = await axios.put('/forgot_password', { data });
      return result;
    } catch (err) {
      return err;
    }
  },

  async generateToken(_, { data }) {
    try {
      let apiData;
      const result = await axios.post('/generate_otp', { data });
      if (result && result.otp_response) {
        const appSecret = window.location.origin.replace(/\/|http:|https:/gi, () => ''); // To extract the domain_url
        const bytes = CryptoJS.AES.decrypt(result.otp_response, appSecret);
        apiData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      }
      return apiData;
    } catch (err) {
      return err;
    }
  },

  async verifyToken(_, { data }) {
    try {
      const result = await axios.post('/verify_otp', { data });
      return result;
    } catch (err) {
      return err;
    }
  },

  async login({ commit }, params) {
    try {
      let data;
      const result = await axios.put('/login_v2', { data: params });
      if (result === '') {
        commit('LOGGED_IN', true);
      }
      if (result && result.otp_response) {
        const appSecret = window.location.origin.replace(/\/|http:|https:/gi, () => ''); // To extract the domain_url
        const bytes = CryptoJS.AES.decrypt(result.otp_response, appSecret);
        const apiData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        data = apiData;
      } else {
        data = result;
      }
      return data;
    } catch (err) {
      return err;
    }
  },

  async acceptTerms() {
    try {
      const result = await axios.put('/transporter/users/accept_terms_conditions');
      return result;
    } catch (err) {
      return err;
    }
  },

  async logout(_, { data, noRedirect }) {
    try {
      _.commit('LOGGED_IN', false);
      await axios.delete('/logout', { });
      localStorage.clear();
      if (data && data.message) {
        window.alert(data.message);
      }
      if (!noRedirect) {
        window.location = '/login';
      }
      return true;
    } catch (err) {
      return err;
    }
  },

  async updateGst({ commit }, { data }) {
    try {
      const result = await axios.put('transporter/gst', { data });
      if (result) {
        commit('UPDATE_GST', result.data);
      }
      return result;
    } catch (err) {
      return err;
    }
  },

  async updateEInvoiceConfig({ commit }, { data }) {
    try {
      const result = await axios.put('transporter/e_invoice', { data });
      return result;
    } catch (err) {
      return err;
    }
  },

  async deleteGst({ commit }, { data: gstIds }) {
    try {
      const result = await axios.put('transporter/remove_gst', { data: { ids: gstIds } });
      if (result) {
        commit('UPDATE_GST', result.data);
      }
      return result;
    } catch (err) {
      return err;
    }
  },
  async uploadLogo({ commit }, data) {
    try {
      commit('setUploading', true);
      const result = await axios.post('/transporter/logo', data, { headers: {
        'Content-Type': 'multipart/form-data',
      } });
      if (result.data) {
        commit('SET_LOGO', result.data);
      }
      return result.data;
    } catch (error) {
      commit('setUploading', false);
      return HandleResponses.Status(error);
    } finally {
      commit('setUploading', false);
    }
  },
  async deleteLogo({ commit }) {
    try {
      const result = await axios.delete('/transporter/logo');
      if (result.data === 'success') {
        commit('SET_LOGO', '');
      }
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async addHsnSac({ commit }, { data }) {
    try {
      const result = await axios.put('transporter/hsn_sac', { data });
      if (result && result.data && result.data === Constants.SUCCESS) {
        commit('ADD_SAC', data);
      }
      return result;
    } catch (err) {
      return HandleResponsesV2.Status(err);
    }
  },

  async getLocales(_, locale) {
    try {
      const result = await axios.get(`/localisation/${locale}`);
      return result.data;
    } catch (err) {
      return err;
    }
  },
  async changeProfilePassword({ commit }, { data, userId }) {
    try {
      const payload = {
        data,
        userId,
      };
      const result = await axios.put('/reset_password', { data: payload });
      return result;
    } catch (err) {
      return { result: false, errMsg: err.data.errors[0].message };
    }
  },
  async reCaptchaVerify(_, reCaptchaVerify) {
    return axios.post('/verify-captcha', { token: reCaptchaVerify });
  },
};


export default actions;
